import React from 'react';
import Swatch from './swatch';
import colorSwatchesStyles from './colorSwatches.module.pcss';

interface ColorSwatchesProps {
  availableColorSwatches: string[] | null;
  showPlaceholder?: boolean;
}

const MAX_COLOR_SWATCHES = 4;

function ColorSwatches({
  availableColorSwatches,
  showPlaceholder = false
}: ColorSwatchesProps): React.ReactElement | null {
  const Swatches = availableColorSwatches && availableColorSwatches.length > 0 && (
    <div className={colorSwatchesStyles['color-swatches']}>
      {availableColorSwatches?.map((swatch, i) => i < MAX_COLOR_SWATCHES && <Swatch key={swatch} swatch={swatch} />)}
    </div>
  );
  const Placeholder = showPlaceholder && <div className={colorSwatchesStyles['color-swatches']} />;
  return Swatches || Placeholder || null;
}

export default ColorSwatches;
